import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="font-heading text-2xl font-bold tracking-tight">
                <span className="text-primary-500">开</span>体育在线
              </Link>
              <p className="mt-4 text-sm text-foreground-300 leading-relaxed">
                开体育在线为您提供全面的体育赛事直播、赛程资讯与竞技互动体验。覆盖足球、篮球、综合格斗等热门项目，随时随地享受精彩体育世界。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold mb-4 text-white">热门分类</h4>
              <div className="flex flex-col gap-2">
                {categories.slice(0, 4).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold mb-4 text-white">快速链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
                <Link to="/category/football" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">足球赛事</Link>
                <Link to="/category/basketball" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">篮球赛事</Link>
                <Link to="/category/mma" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">综合格斗</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold mb-4 text-white">联系我们</h4>
              <div className="flex flex-col gap-3 text-sm text-foreground-300">
                <div className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-500"></i>
                  <span>contact@kaitiyuonline.com</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-phone-line text-primary-500"></i>
                  <span>400-888-6688</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-primary-500"></i>
                  <span>中国北京市朝阳区体育中心</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 开体育在线. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">服务条款</a>
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">广告合作</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}